import { Component } from '@angular/core';

@Component({
  selector: 'app-orders-data-empty',
  templateUrl: './orders-data-empty.component.html',
  styleUrls: ['./orders-data-empty.component.scss']
})
export class OrdersDataEmptyComponent {

}
